/* 
  ### SVG Controller for the Page Customized ### 
  Unregulated page components.
*/

// Common
import Comm_TabModalContainer from '../01_ModalContainer'

// ------------------------------------------------------------------------------------------------------------------------------------------------

export default {
  Comm_TabModalContainer,
}
